export const getRoute = (route: string, params: Record<string, string> = {}) => {
  return route.replace(/:([a-zA-Z0-9]+)\??/g, (_, variableName) => params[variableName] ?? '');
};
